export enum SubscriptionPlanType {
    Financial = "financial",
    Academia = "academia",
    Government = "government",
    Commercial = "commercial",
    Individual = "individual",
    Enterprise = "gse_enterprise",
}

type IntervalUnit = "day" | "week" | "month" | "year";

export interface SubscriptionPlan {
    name: string;
    plan: SubscriptionPlanType;
    price?: number; // In cents
    interval: IntervalUnit;
    intervalCount: number;
}

export const SUBCRIPTION_PLANS: SubscriptionPlan[] = [
    {
        plan: SubscriptionPlanType.Financial,
        name: "Financial",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: SubscriptionPlanType.Academia,
        name: "Academia",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: SubscriptionPlanType.Government,
        name: "Government",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: SubscriptionPlanType.Commercial,
        name: "Commercial",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: SubscriptionPlanType.Individual,
        name: "Individual",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: SubscriptionPlanType.Enterprise,
        name: "Enterprise",
        interval: "year",
        intervalCount: 1,
    },
];
